<template>
    <div class="messagesSecurity">
        <p v-if="isLaunchSystemPlan" class="messagesSecurity_text">
            {{ translateWord('Entendo que estou assinando a plataforma Builderall e que meu cartão será cobrado em {0}{1} hoje pelos primeiros 3 meses de acesso, e depois {0}{2} mensais posteriormente, a menos que eu cancele. Reconheço que posso cancelar a qualquer momento criando um ticket ou entrando em contato com nossa equipe de suporte via chat ao vivo.',
            [
                product.currencySymbol,
                launchAmounts.first_payment + ((product.isTheCurrency.eur && vatFee.percentage > 0) ? ' + VAT' : ''),
                launchAmounts.recurring + ((product.isTheCurrency.eur && vatFee.percentage > 0) ? ' + VAT' : '')
            ]) }}
        </p>

        <p v-else-if="isPaymentDomainRegistry" class="messagesSecurity_text domainRegistry">
            {{ translateWord('Você está comprando o dominio: {0}. e poderá utilizá-lo por {1} ano, após este período será necessário efetuar o pagamento para renovação',
            [
            product.domain,
            product.domainTime
            ]) }}

            <!--{{ translateWord('Entendo que estou realizando o pagamento de {0} {1} e que o mesmo deverá ser renovado anualmente',
            [
                product.currencySymbol,
                product.isTheCurrency.eur ? productAmountPlusVatFee(false, true) : product.amount,
            ]) }}-->
        </p>

        <p v-else-if="isPaymentDomain || isPaymentDomainExtraConnection" class="messagesSecurity_text">
            {{ translateWord('Entendo que estou realizando o pagamento de {0} {1} e que o mesmo deverá ser renovado anualmente',
            [
            product.currencySymbol,
            product.isTheCurrency.eur ? productAmountPlusVatFee(false, true) : product.amount,
            ]) }}
        </p>

        <p v-else-if="product.isTrialDays && hasBundlePlan" class="messagesSecurity_text">
            {{ translateWord('Entendo que estou assinando um plano gratuito Builderall. Reconheço que posso cancelar a qualquer momento criando um tíquete ou entrando em contato com nossa equipe de suporte por chat ao vivo.') }}
        </p>

        <p v-else-if="product.isTrialDays && !product.isAmountFirstMonth" class="messagesSecurity_text">
            {{ translateWord('Entendo que estou aderindo à plataforma Builderall e que no meu cartão será cobrado o valor de {0} {1}, apos o período de {2} dias de teste. Eu reconheço que posso cancelar a qualquer momento criando um tíquete ou entrando em contato com nossa equipe de suporte por chat ao vivo',
            [
            product.currencySymbol,
            product.isTheCurrency.eur ? productAmountPlusVatFee(false, true) : product.amount,
            product.trialDays
            ]) }}
        </p>

        <p v-else-if="hasCouponAndIsValid && coupon.period == 'FOREVER'" class="messagesSecurity_text">
            {{ translateWord('Entendo que estou assinando a plataforma Builderall e que meu cartão será cobrado agora e mensalmente no valor de {0}{1}. Reconheço que posso cancelar a qualquer momento criando um tíquete ou entrando em contato com nossa equipe de suporte por chat ao vivo.',
            [
            product.currencySymbol,
            product.isTheCurrency.eur ? productAmountPlusVatFee(false, true) : product.amountCoupon,
            ]) }}
        </p>

        <p v-else-if="hasCouponAndIsValid && coupon.periodTime" class="messagesSecurity_text">
            {{ translateWord('Entendo que estou assinando a plataforma Builderall e que durante {0} meses meu cartão será cobrado {1} {2} e após esse período meu cartão começará a ser cobrado {1} {3}. Reconheço que posso cancelar a qualquer momento acessando a área de cobrança em meu conta ou criando um ticket ou entrando em contato com nossa equipe de suporte via chat ao vivo.',
            [
            coupon.periodTime,
            product.currencySymbol,
            product.isTheCurrency.eur ? productAmountPlusVatFee(false, true) : product.amountCoupon,
            product.isTheCurrency.eur ? productAmountPlusVatFee(true) : product.amount,

            ]) }}
        </p>

        <p v-else-if="hasCouponAndIsValid && !product.isAmountFirstMonth" class="messagesSecurity_text">
            {{ translateWord('Entendo que estou aderindo à plataforma Builderall e que no meu cartão será cobrado o valor de {0} {2}. e na recorrência o valor de {0} {1}. Eu reconheço que posso cancelar a qualquer momento criando um tíquete ou entrando em contato com nossa equipe de suporte por chat ao vivo',
            [
            product.currencySymbol,
            product.isTheCurrency.eur ? productAmountPlusVatFee(false, true) : product.amountCoupon,
            product.isTheCurrency.eur ? productAmountPlusVatFee(true) : product.amount,

            ]) }}
        </p>

        <p v-else-if="product.isAmountFirstMonth" class="messagesSecurity_text">
            {{ translateWord('Entendo que o Primeiro pagamento do mês sera de {0} {1}, depois de 30 dias o valor de {2} {3} começa a ser debitado na recorrência',
            [
            product.currencySymbol,
            (hasCouponAndIsValid && product.isTheCurrency.eur ? productAmountPlusVatFee(true) : (product.isTheCurrency.eur ? productAmountPlusVatFee(false, false, true) : (hasCouponAndIsValid ? product.amountCoupon : product.amountFirstMonth))),
            product.currencySymbol,
            product.isTheCurrency.eur ? productAmountPlusVatFee(false, true) : product.amount
            ]) }}
        </p>

        <p v-else class="messagesSecurity_text">
            {{ translateWord('Entendo que estou aderindo à plataforma Builderall e que no meu cartão será cobrado o valor de {0} {1}. Eu reconheço que posso cancelar a qualquer momento criando um tíquete ou entrando em contato com nossa equipe de suporte por chat ao vivo',
            [
            product.currencySymbol,
            product.isTheCurrency.eur ? productAmountPlusVatFee : product.amount
            ]) }}
        </p>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Helper from '../assets/js/helper';

export default {
    name: "MessagesSecurity",
    computed: {
        ...mapState([
            'isPaymentDomain',
            'isPaymentDomainExtraConnection',
            'isPaymentDomainRegistry',
            'coupon',
            'localeUser',
            'vatFee',
            'plano'
        ]),
        ...mapGetters([
            'translateWord',
            'product',
            'productAmountPlusVatFee',
            'hasCouponAndIsValid',
            'hasBundlePlan',
            'isLaunchSystemPlan'
        ]),
        launchAmounts(){
            let countryCode = (this.localeUser.country || '').toUpperCase();
            let amountsTable = this.plano.slug == 'build-win-plan' ? Helper.buildWinPlanAmounts : Helper.launchSystemPlanAmounts;
            return amountsTable[countryCode] || { first_payment: '0.00', recurring: '0.00' };
        }
    }
}
</script>

<style lang="scss" scoped>
    .messagesSecurity_text{
        font-size: 0.7em;
        
        &.domainRegistry{
            margin-top: 15px;
            text-align: center;
        }

        @media (max-width: 767px) {
            margin-top: 25px;
        }
    }
</style>